import { actionTypes } from '../actions/api';

export const addApiException = (exception) => ({ type: actionTypes.addApiException, exception });

